import apiurl from './apiurl';
const axios = require('axios');

const generarDocumentoManual = async (params, idToken) => {
    return axios({
        method: 'POST',
        url: apiurl + 'generardocumentomanual',
        headers: {
            'content-type': 'application/json',
            'Authorization': "Bearer " + idToken
        },
        data: params,
        crossdomain: true,
    });
};

export default generarDocumentoManual;
